<template>
  <span v-resize="checkMobile" data-testid="archive-bookings-page">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <!-- шапка в дизайне bookings/list: сегмент скоупа («Архив» подсвечен,
         Активные/Неактивные ведут в список), поиск и экспорт — в командной панели.
         Без счётчика, тумблера обкатанных и переключателя вида (решение USER) -->
    <bookings-command-bar view="archive" :filters="{ search }"
      :show-live="false" :xlsx-loading="isLoadingToXlsx" search-testid="archive-bookings-search"
      @input="search = $event.search" @refresh="getDataFromApi" @export-xlsx="toXlsx" />
    <v-data-table v-model="selected" :headers="headers" :items="bookings" :search="search" :loading="isLoading"
      :loading-text="$t('custom.loading_table')" :server-items-length.sync="total" :options.sync="tableOptions"
      :page.sync="page" item-key="id" :class="!isMobile ? 'elevation-1 mt-2' : 'elevation-1 mt-2 is-mobile'"
      :items-per-page="50" mobile-breakpoint="100" dense :footer-props="tableFooterProps([50, 150, 300], `{0} ${$t('custom.of')} ${total}`)">
      <template slot="header" slot-scope="props">
        <tr>
          <th v-for="header in props.headers" :key="header.text" nowrap>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template slot="item" slot-scope="props">
        <tr @dblclick="replaceToBooking(props.item)" style="cursor: pointer"
          :class="!props.item.technical ? '' : 'blue-grey lighten-4'">
          <td class="text-center" :key="props.item.id">
            <rent-to-own-number-chip v-if="props.item.rent_to_own === true" small :link="false" :booking="props.item" />
            <template v-else>{{ props.item.id }}</template>
          </td>
          <td class="text-center" nowrap>
            {{ formatCreatedAt(props.item.created_at) }}
          </td>
          <td class="text-center" nowrap>
            {{ formatCreatedAt(props.item.archived_date) }}
          </td>
          <td class="text-center" nowrap>
            <v-icon v-if="props.item.ride" color="success" v-tooltip="{
              content: $t('bookings.ride_true'),
              placement: 'bottom-center',
              classes: ['info'],
              targetClasses: ['it-has-a-tooltip'],
              delay: {
                show: 500,
                hide: 500,
              },
            }">
              mdi-garage-variant
            </v-icon>
            <v-icon v-else color="secondery"> mdi-minus </v-icon>
          </td>
          <td class="text-center" nowrap>
            <v-icon v-if="props.item.auto_archived" color="error">
              mdi-robot-outline
            </v-icon>
            <v-icon v-else color="success"> mdi-face-man-outline </v-icon>
          </td>
          <td class="text-center">
            <v-icon small class="mr-2" @click="replaceToBooking(props.item)" :title="$t('archive.booking_info')">
              mdi-eye-outline
            </v-icon>
            <v-icon v-if="canDeleteBooking(props.item)" small @click="deleteItem(props.item)">
              mdi-delete-forever
            </v-icon>
          </td>
          <td class="text-center">
            <v-icon class="mr-2" color="red" v-if="!props.item.active && !props.item.archive"
              @click="archiveBooking(props.item)">
              mdi-archive-arrow-down
            </v-icon>
            <v-icon class="mr-2" color="green" v-if="!props.item.active && props.item.archive"
              @click="unarchiveBooking(props.item)">
              mdi-archive-arrow-up
            </v-icon>
          </td>
          <td class="text-center">
            <router-link :to="{ path: `/cars/${props.item.car_id}` }">{{ props.item.car_name }}({{ props.item.car_code
            }})</router-link>
          </td>
          <td class="text-center" nowrap>
            <router-link :class="checkClientCategory(props.item.client_id)"
              :to="{ name: 'ClientCard', params: { id: props.item.client_id } }">{{ props.item.first_name ?
                props.item.first_name[0] : "" }}.
              {{ props.item.middle_name ? props.item.middle_name[0] : "" }}.
              {{
                props.item.last_name ? props.item.last_name : ""
              }}</router-link>
          </td>
          <td class="text-center" nowrap>
            {{ formatBookingDates(props.item.start_date) }}
          </td>
          <td class="text-center" nowrap>
            {{ formatBookingDates(props.item.end_date) }}
          </td>
          <td class="text-center">{{ props.item.days }}</td>
          <td class="text-center">{{ props.item.location_start }}</td>
          <td class="text-center">{{ props.item.location_end }}</td>
        </tr>
      </template>
      <template slot="no-data">
        {{ $t("custom.no_data_in_table") }}
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
        {{ $t("tables.no_search_result", { msg: search }) }}
      </v-alert>
    </v-data-table>
  </span>
</template>
<script>
import { translateCountCategory } from "@/utils/countCategory";
import { Capacitor } from "@capacitor/core";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
// moment.locale("ru");
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import xlsx from "json-as-xlsx";
import { saveAs } from "file-saver";
import BookingsCommandBar from "@/components/dashboard/bookings/BookingsCommandBar.vue";
import RentToOwnNumberChip from "@/components/dashboard/bookings/RentToOwnNumberChip.vue";
export default {
  components: { BookingsCommandBar, RentToOwnNumberChip },
  pullToRefresh: true,
  data() {
    return {
      bookings: [],
      all_bookings: [],
      ride_bookings: [],
      workers_names: [],
      payment: {
        cash: null,
        booking_id: null,
      },
      showArrivalPayments: false,
      arrival_payments: {
        gas: 0,
        damages: 0,
        clean: 0,
        delivery: 0,
        additional_hours: 0,
        other: 0,
      },
      prolongData: {
        days: null,
        price: null,
        additional_hours: null,
        paid: null,
      },
      selected: [],
      search: "",
      rowsPerPageItems: [10, 25, 50, 100],
      headers: [
        { text: this.$t("custom.number"), value: "id", align: "center" },
        {
          text: this.$t("custom.created"),
          value: "created_at",
          align: "center",
        },
        {
          text: this.$t("custom.archived_date"),
          value: "archived_date",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("bookings.ride_true"),
          value: "ride",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("custom.who_archived"),
          value: "auto_archived",
          sortable: false,
          align: "center",
        },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
        { text: this.$t("custom.actions"), sortable: false, align: "center" },
        { text: this.$t("cars.name"), value: "car_code", align: "center", sortable: false },
        { text: this.$t("custom.client"), value: "last_name", align: "center", sortable: false },
        {
          text: this.$t("custom.start"),
          value: "start_date_formatted",
          align: "center",
        },
        { text: this.$t("custom.end"), value: "end_date_formatted", align: "center" },
        { text: this.$t("custom.days"), value: "days", align: "center", sortable: false },
        {
          text: this.$t("custom.checkin"),
          value: "location_start",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("custom.checkout"),
          value: "location_end",
          align: "center",
          sortable: false
        },
      ],
      sortingBookings: { sortBy: "created_at", descending: true },
      options: {
        sortBy: "car_code",
      },
      calendarConfig: {
        type: "string",
        mask: "DD-MM-YYYY H:mm", // Uses 'iso' if missing,
        // timeAdjust: "12:00:00",
      },
      calendar_attributes: [
        {
          key: "today",
          highlight: {
            color: "red",
            fillMode: "outline",
          },
          dates: new Date(),
        },
      ],
      sort_date_menu: false,
      start_date_format: null,
      sort_date_between_menu: false,
      sort_date: null,
      sort_date_between: null,
      configSort: {
        altFormat: "d-m-Y",
        altInput: true,
        dateFormat: "d-m-Y",
      },
      page: 1,
      per_page: 50,
      sort_by: "id",
      direction: "desc",
      tableOptions: {},
      total: 0,
      timeout: null,
      isMobile: false,
      isLoading: false,
      isLoadingToXlsx: false,
      error: "",
    };
  },
  mounted() {
    let self = this;
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      // this.isLoading = true;
      // this.show_ride_booking = this.$store.getters.getShowRideBookings;
    } else {
      this.$store.commit("unsetCurrentUser");
      this.$router.push({ path: `/signin` }).catch((err) => { });
    }
  },
  watch: {
    sort_date() {
      this.getDataFromApi();
    },
    sort_date_between() {
      let self = this;
      if (this.sort_date_between) {
        this.ride_bookings = [];
        this.bookings = [];
        this.all_bookings.map(function (booking) {
          if (booking.ride == true) {
            self.ride_bookings.push(booking);
          }
        });
        this.all_bookings.map(function (booking) {
          self.bookings.push(booking);
        });

        this.bookings = this.bookings.filter((x) =>
          moment(self.sort_date_between, "YYYY-MM-DD").isBetween(
            moment(x.start_date, "DD-MM-YYYY"),
            moment(x.end_date, "DD-MM-YYYY"),
            "day"
          )
        );
        this.ride_bookings = this.ride_bookings.filter((x) =>
          moment(self.sort_date_between, "YYYY-MM-DD").isBetween(
            moment(x.start_date, "DD-MM-YYYY"),
            moment(x.end_date, "DD-MM-YYYY"),
            "day"
          )
        );
      } else {
        this.ride_bookings = [];
        this.bookings = [];
        this.all_bookings.map(function (booking) {
          if (booking.ride == true) {
            self.ride_bookings.push(booking);
          }
        });
        this.all_bookings.map(function (booking) {
          self.bookings.push(booking);
        });
      }
    },
    tableOptions(pagination) {
      this.page = pagination.page;
      this.per_page = pagination.itemsPerPage;
      this.sort_by = pagination.sortBy[0] ? pagination.sortBy[0] : "id";
      this.direction = pagination.sortDesc[0] ? "asc" : "desc";
      this.getDataFromApi();
    },
    search() {
      if (this.search == "") {
        this.search = null;
      } else {
        let self = this;
        this.page = 1;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.getDataFromApi();
          }, 300); // delay
        }
        debounce();
      }
    },
  },
  computed: {
    sort_date_formatted() {
      if (this.sort_date) {
        return moment(this.sort_date, "YYYY-MM-DD").format("DD-MM-YYYY");
      } else {
        return "";
      }
    },
    sort_date_between_formatted() {
      if (this.sort_date_between) {
        return moment(this.sort_date_between, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );
      } else {
        return "";
      }
    },
    toolbar_height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 180
        case 'sm': return 180
        default: return 65
      }
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
    show_ride_booking: {
      get() {
        return this.$store.getters.getShowRideBookings;
      },
      set(value) {
        this.$store.commit("show_ride_bookings", value);
      }
    }
  },
  methods: {
    getDataFromApi() {
      let self = this;
      this.isLoading = true;
      this.axios
        .post(
          `/api/v1/archive_bookings_v2`,
          {
            search: this.search,
            page: this.page,
            per_page: this.per_page,
            sort_by: this.sort_by,
            direction: this.direction,
            // тумблер обкатанных убран из шапки (решение USER) — всегда все брони,
            // скрытое store-состояние не должно фильтровать выборку без UI
            rided: false,
            // sort_date in seconds
            // start_or_end: moment(this.sort_date).unix() / 1000,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.bookings = [];
          response.data.bookings.data.forEach((booking) => {
            this.bookings.push(booking.attributes);
          });
          this.total = response.data.total;
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isLoading = false));
    },
    deleteItem(booking) {
      if (booking.vseprokaty_id) {
        this.$notify(this.$t("agregator.no_delete_aggregator"), this.$t("agregator.no_delete_aggregator_text"), "warning", 5000);
        return;
      }
      this.$confirm({
        title: this.$t("custom.you_sure_title"),
        text: this.$t("custom.you_sure_text"),
        icon: "mdi-alert-circle-outline",
        confirmButtonText: this.$t("custom.you_sure_yes"),
        cancelButtonText: this.$t("custom.you_sure_no"),
      }).then((result) => {
        if (result) {
          this.axios
            .delete(`/api/v1/bookings/${booking.id}`, {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            })
            .then((response) => {
              this.bookings.splice(this.bookings.indexOf(booking), 1);
              this.ride_bookings.splice(this.ride_bookings.indexOf(booking), 1);
              // «Удалено» — только после ответа сервера: отказ (403, 422) раньше сопровождался ложным успехом.
              this.$notify(this.$t("custom.deleted"), this.$t("custom.deleted_ok"), "success", 2000);
            })
            .catch((error) =>
              this.setError(error, this.$t("errors.archive_bookings_delete"))
            );
        }
      });
    },
    findWorker(id) {
      let name;
      if (this.workers_names.find((worker) => worker.id == id)) {
        name = this.workers_names.find((worker) => worker.id == id).name
          ? this.workers_names.find((worker) => worker.id == id).name
          : this.workers_names.find((worker) => worker.id == id).email;
      }
      if (name) {
        return name;
      } else {
        return id;
      }
    },
    toXlsx() {
      if (this.isStaff) {
        let bookings = this.all_bookings;
        this.isLoadingToXlsx = true;
        this.axios
          .get("/api/v1/get_workers_names_with_ids", {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.workers_names = response.data;
            let bookings_data = this.bookings;

            let data = [
              {
                sheets: "BookingArchive",
                columns: [
                  { label: "ID", value: "id" },
                  { label: this.$t("custom.created_at"), value: "created_at" },
                  { label: this.$t("bookings.name"), value: "first_name" },
                  {
                    label: this.$t("bookings.middlename"),
                    value: "middle_name",
                  },
                  { label: this.$t("bookings.lastname"), value: "last_name" },
                  { label: this.$t("cars.name"), value: "car_name" },
                  { label: this.$t("doc_variables.car_code"), value: "car_code" },

                  { label: this.$t("bookings.start_date"), value: "start_date" },
                  { label: this.$t("bookings.end_date"), value: "end_date" },
                  { label: this.$t("bookings.days"), value: "days" },
                  { label: this.$t("bookings.add_hours_short"), value: "additional_hours" },
                  { label: this.$t("bookings.price"), value: "price" },
                  {
                    label: this.$t("bookings.rental_cost"),
                    value: "rental_cost",
                  },
                  { label: this.$t("bookings.delivery"), value: "delivery" },
                  {
                    label: this.$t("bookings.checkout"),
                    value: "delivery_end",
                  },
                  // UAT 2026-08-07: колонки идут подряд — в файле было два
                  // столбца «Оборудование»; легаси-сумма разведена лейблом.
                  { label: this.$t("bookings.other_equipment"), value: "equipment" },
                  // FT-102: каталожное оборудование
                  { label: this.$t("booking_addons.title"), value: "addons_cost" },
                  { label: this.$t("bookings.insurance"), value: "insurance" },
                  {
                    label: this.$t("bookings.clean"),
                    value: "clean_payment",
                  },
                  {
                    label: this.$t("bookings.add_drivers_2"),
                    value: "add_drivers_cost",
                  },
                  { label: this.$t("bookings.hours_cost"), value: "hours_cost" },
                  {
                    label: this.$t("bookings.mileage_cost"),
                    value: "mileage_cost",
                  },
                  { label: this.$t("bookings.damages"), value: "damage" },
                  { label: this.$t("bookings.gas"), value: "gas" },
                  { label: this.$t("bookings.for_fines"), value: "fine" },
                  { label: this.$t("bookings.other"), value: "other" },
                  {
                    label: this.$t("bookings.for_other_end"),
                    value: "other_end",
                  },
                  {
                    label: this.$t("bookings.hours_cost_end"),
                    value: "hours_cost_end",
                  },
                  {
                    label: this.$t("clients.client_source"),
                    value: "client_source",
                  },
                  {
                    label: this.$t("clients.source"),
                    value: "source",
                  },
                  {
                    label: this.$t("bookings.checkiner"),
                    value: (row) => {
                      return this.findWorker(row.start_worker_id);
                    },
                  },
                  {
                    label: this.$t("bookings.checkouter"),
                    value: (row) => {
                      return this.findWorker(row.end_worker_id);
                    },
                  },
                ],
                content: bookings_data,
              },
            ];
            let settings = {
              fileName: "booking_archive", // Name of the resulting spreadsheet
              extraLength: 3, // A bigger number means that columns will be wider
              writeMode: "write", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
              writeOptions: {
                bookType: "xlsx",
                type: "array",
              }, // Style options from https://docs.sheetjs.com/docs/api/write-options
              RTL: false, // Display the columns from right-to-left (the default value is false)
            };
            let wbout = xlsx(data, settings);
            var blob_data = new Blob([new Uint8Array(wbout)], { type: "application/octet-stream" });
            if (!this.isNative) {
              saveAs(blob_data, 'booking_archive.xlsx');
            } else {
              if (Filesystem.checkPermissions()) {
                const getBase64FromBlob = async (blob) => {
                  return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                      const base64data = reader.result;
                      resolve(base64data);
                    }
                  });
                }
                getBase64FromBlob(blob_data).then(
                  (base64) => {
                    // save file
                    async function writeFile() {
                      return await Filesystem.writeFile({
                        path: 'booking_archive.xlsx',
                        data: base64,
                        directory: Directory.Documents,
                      });
                    }
                    let file_uri = null
                    let writedFile = writeFile().then((getUriResult) => {
                      // share file opened file
                      let shareFile = async () => {
                        await Share.share({
                          title: 'Download document',
                          files: [getUriResult.uri],
                        }).catch((error) => {
                          console.log("shareFile", error)
                        });
                      };
                      let sharedFile = shareFile();

                    }).catch((error) => {
                      console.log("shareFile", error)
                    });
                  }
                );
              } else {
                Filesystem.requestPermissions();
              }
            }
          })
          .catch((error) => {
            this.setError(error, "Something went wrong in get_workers_names");
            console.log(error);
          })
          .finally(() => (this.isLoadingToXlsx = false));

      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    translateCategory(category) {
      return translateCountCategory((key) => this.$t(key), category);
    },
    // «Удалить» — как в карточке (BookingCard.vue, canDeleteBooking) и как сервер (bookings#destroy, api#1057):
    // только superadmin и admin, не активное и не договорное бронирование. Менеджер удалял из архива,
    // хотя в карточке кнопки у него нет (решение USER 23.10.2026: удаление — admin+).
    canDeleteBooking(booking) {
      const isAdminPlus = this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
      return Boolean(isAdminPlus && booking && !booking.active && !booking.rent_to_own);
    },
    toggleShowBookings() {
      this.show_ride_booking = !this.show_ride_booking;
      this.getDataFromApi();
    },
    formatCreatedAt(date) {
      if (moment(date).isValid()) {
        return moment.parseZone(date).format("DD MMM H:mm");
      } else {
        return date;
      }
    },
    checkClientCategory(client_id) {
      let client = this.set_client;
      if (client && client.category == this.$t("clients_groups.new")) {
        return "" + client.debt > 0 ? "orange darken-4" : "";
      } else if (
        client &&
        client.category == this.$t("clients_groups.permanent")
      ) {
        return `green--text ${client.debt > 0 ? " orange darken-4" : ""}`;
      } else if (client && client.category == this.$t("clients_groups.gray")) {
        return `grey--text text-decoration-line-through ${client.debt > 0 ? " orange darken-4" : ""
          }`;
      } else if (client && client.category == this.$t("clients_groups.black")) {
        return `black--text text-decoration-line-through ${client.debt > 0 ? " orange darken-4" : ""
          }`;
      } else if (client && client.category == this.$t("clients_groups.loyal")) {
        return `deep-purple--text ${client.debt > 0 ? " orange darken-4" : ""}`;
      }
    },
    formatBookingDates(date) {
      return moment(date, "DD-MM-YYYY H:mm").format("DD MMM H:mm");
    },
    replaceToBooking(booking) {
      this.$router.push({ path: `/bookings/${booking.id}` }).catch((err) => { });
    },
    archiveBooking(booking) {
      if (this.isStaff) {
        let self = this;
        if (booking) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/bookings/${booking.id}`,
              {
                bookings: {
                  archive: true,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let foundIndex = this.bookings.findIndex(
                (element) => element.id === booking.id
              );
              this.bookings[foundIndex].archive = true;
            })
            .catch((error) => {
              this.setError(
                error,
                this.$t("errors.archive_bookings_archiving")
              );
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    unarchiveBooking(booking) {
      if (this.isStaff) {
        let self = this;
        if (booking) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/bookings/${booking.id}`,
              {
                bookings: {
                  archive: false,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let foundIndex = this.bookings.findIndex(
                (element) => element.id === booking.id
              );
              this.bookings[foundIndex].archive = false;
            })
            .catch((error) => {
              this.setError(
                error,
                this.$t("errors.archive_bookings_unarchiving")
              );
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
};
</script>
